import React, { Component } from 'react';
import { createStore } from '@spyna/react-store';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import Navbar from "./components/navbar.js";
import devpage from "./pages/devpage";
import page404 from "./pages/404";
import BlogPage from './pages/blog/page';
import Article from './pages/blog/article';
import RegisterPage from './pages/register';
import ModelPage from './pages/model/page';
import WeatherPage from './pages/weather/page';
import TCPage from './pages/tc/tc';
import VideoPage from "./pages/video/main";
import PosterPage from "./pages/weather/poster";
import NoticeBanner from './components/notice';
import './styles/main.css';
import EarthquakeList, { EarthquakeDetail } from './pages/weather/quake.js';

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      articles: [],
      moreArticle: false,
      tagFilter: '所有',
      tags: [],
      scrollY: null
    }
  }

  render() {
    return (
      <BrowserRouter>
        <div>
          <Navbar/>
          <a href='https://next.easterlywave.com' className='is-fullwidth'>
            <div className='notification is-info has-text-centered'>
              实验性新站正在测试中： next.easterlywave.com
            </div>
          </a>
          <NoticeBanner/>
          <main className='bd-main'>
            <div className='container'>
              <Switch>
                <Route path='/' exact component={() => <BlogPage hp={this.state} />} />
                <Route path='/weather/' component={WeatherPage} />
                <Route path='/typhoon/' component={TCPage} />
                <Route path='/model/' component={ModelPage} />
                <Route path='/register/' component={RegisterPage} />
                <Route path='/about/' component={devpage} />
                <Route path='/blog/:pk/' component={({match}) => <Article pk={match.params.pk}/>} />
                <Route path='/videomaker/' component={VideoPage} />
                <Route path='/poster/' component={PosterPage} />
                <Route path='/earthquake/' exact component={EarthquakeList} />
                <Route path='/earthquake/:id/' component={({match}) => <EarthquakeDetail eventid={match.params.id} />} />
                <Route component={page404} />
              </Switch>
            </div>
          </main>
        </div>
      </BrowserRouter>
    );
  }
}

const initialValue = {
  userLogined: false,
  userName: '',
  userPlevel: 0
}

export default createStore(App, initialValue);
